exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".digestSection .dataQuizzes .itemHeader .student{display:inline-block}.digestSection .dataQuizzes .itemHeader .date{float:right;position:relative;top:8px;font-size:.8em}.digestSection .dataQuizzes .itemHeader .title{margin-bottom:0}.digestSection .dataQuizzes .answerDisplay{padding-bottom:0;margin-top:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/data_quizzes.scss
// module id = 1261
// module chunks = 0